'use client'
import { useState } from 'react'
import { copyTextToClipboard } from 'src/_helpers/copyToClipboard'
import Typography from './Typography'
import Tag from './Tag'

const TAG_VARIANTS = [
  {
    id: 'default',
    title: 'Default',
    description: 'Neutral tag for secondary metadata and filters.',
    props: {
      type: 'default',
      label: 'Tag label',
    },
    code: `<Tag type="default" label="Tag label" />`,
  },
  {
    id: 'new',
    title: 'New',
    description: 'Highlights new or recently added content with a status dot.',
    props: {
      type: 'new',
      label: 'Nowość',
    },
    code: `<Tag type="new" label="Nowość" />`,
  },
  {
    id: 'open-access',
    title: 'Open Access',
    description: 'Marks freely available publications with a padlock icon.',
    props: {
      type: 'open-access',
      label: 'Open Access',
    },
    code: `<Tag type="open-access" label="Open Access" />`,
  },
  {
    id: 'preview',
    title: 'Preview',
    description: 'Marks upcoming publications with a dashed circle icon.',
    props: {
      type: 'preview',
      label: 'Zapowiedź',
    },
    code: `<Tag type="preview" label="Zapowiedź" />`,
  },
]

export default function TagExamples() {
  const [copiedId, setCopiedId] = useState(null)

  const handleCopy = async (id, text) => {
    const success = await copyTextToClipboard(text)
    if (!success) return

    setCopiedId(id)
    setTimeout(() => setCopiedId(null), 2000)
  }

  return (
    <div className="space-y-40">
      <Typography variant="h2">Tag Components</Typography>

      <Typography variant="body1">
        Compact status tags built with Adobe Garamond typography. Tags stay inline with text, use 3px vertical and 9px
        horizontal padding, and support variants for neutral and highlighted states.
      </Typography>

      <div className="grid grid-cols-1 t:grid-cols-2 gap-16">
        {TAG_VARIANTS.map(({ id, title, description, props, code }) => (
          <div key={id} className="border border-basic-gray6 bg-basic-white rounded-lg p-16 space-y-8">
            <div className="flex items-center justify-between gap-8">
              <Typography variant="body3">{title}</Typography>
              <button
                onClick={() => handleCopy(id, code)}
                className="px-4 py-1 text-xs bg-basic-gray6 hover:bg-basic-gray5 text-basic-black rounded transition-colors"
              >
                {copiedId === id ? 'Copied!' : 'Copy'}
              </button>
            </div>

            <Tag {...props} />

            <div className="space-y-2">
              <Typography variant="body4" color="text-basic-gray2">
                {description}
              </Typography>
            </div>

            <code className="block text-xs text-basic-gray3 bg-basic-gray8 rounded px-4 py-2">{code}</code>
          </div>
        ))}
      </div>
    </div>
  )
}
